<template>
    <div id="app" class="app">
        <transition name="fade" appear>
            <router-view/>
        </transition>
        <!-- 提示框 -->
        <transition name="fade">
            <div class="app__message" v-show="showMessage">
                <div class="app__message__cnt" v-html="message"></div>
            </div>
        </transition>
        <!-- 兑换规则 -->
        <transition name="fade">
            <div class="app__form__modal" v-show="showRule" @touchmove.stop>
                <div class="app__form__modal__cnt animated bounceInDown">
                    <div class="app__form__modal__cnt__inner">
                        <img src="http://cdn.shikehuyu.com/card/form-desc.png?v=1.0.2" class="app__form__modal__cnt__inner__desc">
                    </div>
                    <img src="http://cdn.shikehuyu.com/card/form-line.png?v=1.0.0" class="app__form__modal__cnt__line">
                    <img src="http://cdn.shikehuyu.com/card/form-close.png?v=1.0.0" class="app__form__modal__cnt__close"
                        @click="closeRule">
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            showMessage: false,
            message: '提示信息',
            showRule: false,
        };
    },
    methods: {
        closeRule() {
            this.$bus.playMusic('click');
            this.showRule = false;
        }
    },
    mounted() {
        this.$bus.$on('showMessage', ({ message, timeout }) => {
            clearTimeout(this.showMessageTimeout);
            this.message = message;
            this.showMessage = true;
            this.showMessageTimeout = setTimeout(() => {
                this.showMessage = false;
            }, timeout || 2000);
        });
        this.$bus.$on('showRule', () => {
            this.showRule = true;
        });
    }
};
</script>

<style lang="scss">
@import './style/mixin.scss';

.app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    font-size: .14rem;
    &__message {
        @include fullscreen;
        @include box;
        z-index: 999;
        &__cnt {
            color: white;
            font-size: .14rem;
            line-height: .22rem;
            text-align: center;
            border-radius: .06rem;
            padding: .1rem;
            background: rgba(0, 0, 0, 0.8);
        }
    }
    &__form {
        &__modal {
            @include fullfill;
            @include box;
            z-index: 998;
            background: rgba(0, 0, 0, 0.8);
            &__cnt {
                background: white;
                padding: .14rem;
                position: relative;
                &__inner {
                    position: relative;
                    font-size: 0px;
                    max-height: 84vh;
                    overflow-y: auto;
                    padding: 0 .2rem;
                    font-size: 0;
                    -webkit-overflow-scrolling: touch;
                    &__desc {
                        width: 66vw;
                    }
                }
                &__close {
                    position: absolute;
                    top: 0;
                    right: 0;
                    transform: translate(40%, -40%);
                    width: 9vw;
                }
                &__line {
                    position: absolute;
                    top: 50%;
                    left: .14rem;
                    transform: translate(-50%, -50%);
                    height: 90%;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue